import React from 'react'

// used for return selected ganres with format for api request
const useGenres = (selectedGenres) => {
  // console.log(selecteGenres)
  if (selectedGenres < 1) return ""
  const GenreIds = selectedGenres.map(g => g.id)
  // 1, 2, 3,
  return GenreIds.reduce((acc, curr) => acc + "," + curr)
}

export default useGenres
